import * as React from "react";

const UserIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 155 155" {...props}>
		<path d="M59.09 78.65c-16.1-9.48-22.51-23.35-20.94-40.67.84-9.29 4.91-17.76 11.99-23.92C67.29-.85 89.22.11 104.75 15.01c9.55 9.17 13.01 21.33 11.01 34.23-1.94 12.49-8.45 22.67-20.99 29.28 14.26 4.16 25.53 10.94 34.64 20.98 12.66 13.95 18.82 30.51 18.47 49.33-.07 4.04-2.71 6.61-7.03 6.61-42.61.02-85.23.03-127.84 0-4.13 0-7.1-3.29-7.01-7.74.51-25.7 11.36-45.83 32.75-60.12 5.87-3.92 12.3-6.8 20.33-8.92Z" />
	</svg>
);

export default UserIcon;
